import styled from 'styled-components/macro';
import { FlexNoAlign, FlexAlignRight, FlexJustifyCenter } from '../../../../../../shared-styles/flex';

export const FormHeader = styled.h2`
  color: ${(props) => props.theme.palette.custom.formHeader};
  font-weight: 300
`;

export const TopRowContainer = styled.div`
  ${FlexNoAlign};
  margin: ${(props) => props.theme.spacing(20)} 0;
`;

export const ProblemInputContainer = styled.div`
  flex-basis: 50%;
  padding-right: ${(props) => props.theme.spacing(20)};
`;

export const SubmitButtonContainer = styled.div`
  ${FlexAlignRight}
  margin-top: ${(props) => props.theme.spacing(12)};
`;

export const LoadingContainer = styled.div`
  ${FlexJustifyCenter}
`;
